module.exports = __webpack_public_path__ + "static/media/MattBoatman_sq.63170449.JPG";


//////////////////
// WEBPACK FOOTER
// ./src/MattBoatman_sq.JPG
// module id = 116
// module chunks = 0